module.exports = __webpack_public_path__ + "img/best-price.d2a6795.svg";